
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of water sports in Goa. From exciting jet skiing to relaxing scuba diving, enjoy a fun-filled day on the water with friends and family.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Dive into adventure with the best water sports package in Goa. Enjoy jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for adventure with the Goa Water Sports Package. Enjoy thrilling activities like jet skiing and scuba diving at stunning beaches.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: '5 in 1 water sports in goa, water sports in goa, water sports package in north goa, goa water sports package, goa water sports package price, goa water sports package with scuba diving, south goa water sports package, north goa water sports package, goa water sports package online booking, scuba diving goa water sports package, grande island goa water sports package, scuba diving and water sports in goa, best water sports package in goa',
        },
    
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],


      
      title: 'Water Sports 5-in-1 - Water Sports in Goa',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-sports-5-in-1`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-sports-5-in-1`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-sports-5-in-1`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Sports 5-in-1",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Sports 5-in-1 - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate 5-in-1 water sports adventure in Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-sports-5-in-1",
        "url": "https://www.goa.app/watersports/water-sports-5-in-1",
        "name": "Water Sports 5-in-1",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-03T11%3A09%3A51.107Zparasailing-grande-islands.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SH60F4bOLLxtkUTYF7GuY2TzUT2BJbSyJ25gJfbQbWwQj63894A870E8DskpSMIk0HRQUMR2DxU5p4Q8C4QbJFTSmg9CMRr7LedXnMz86WWdm4PffZwbxvWwgWBW%2FRlxuqz7wah3gJD%2FTCzOolI684Kqhm3q4FidD4v8ZcIBPY8c6pBUjMI72twjJ%2BTFxvUqIOUCHkFa4iq4b388iU0yRn1FwIS56mFfK8SkiHqIxNIXY8JHCnaTeehcquAzxwpJcfRZowFdCRCyRw%2BX5EiKR1g0BpnftyMTkr60mGlztrawqe26T1oVT7W7mMwPglOFPqjUu%2BIjIICWqKxO7Pb1mw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The 5-in-1 Water Sports Package in Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-sports-5-in-1/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-sports-5-in-1"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
        "@type": "Question",
        "name": "What water sports are included in the Goa Water Sports Package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The Goa Water Sports Package typically includes activities like jet skiing, parasailing, scuba diving, banana boat rides, and kayaking."
        }
    },
    {
        "@type": "Question",
        "name": "What is the cost of the Goa Water Sports Package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prices for the Goa Water Sports Package generally start from ₹899 for basic activities and can go up to ₹3,499 for premium packages including scuba diving."
        }
    },
    {
        "@type": "Question",
        "name": "Is scuba diving included in the package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, many Goa Water Sports Packages offer scuba diving as an option, with different packages available for beginners and experienced divers."
        }
    },
    {
        "@type": "Question",
        "name": "Do I need prior experience for water sports?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most water sports in Goa are beginner-friendly, and professional instructors are available to guide you, especially for scuba diving and jet skiing."
        }
    },
    {
        "@type": "Question",
        "name": "What is the best time for water sports in Goa?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The best time for water sports in Goa is from November to April when the weather is pleasant and the sea is calm."
        }
    },
    {
        "@type": "Question",
        "name": "Are safety measures provided during water sports?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, all water sports operators in Goa prioritize safety and provide necessary safety gear, such as life jackets and helmets, for participants."
        }
    },
    {
        "@type": "Question",
        "name": "Can I book the Goa Water Sports Package online?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely! You can easily book the Goa Water Sports Package online through various platforms, including the Goa App, for convenient access to deals and offers."
        }
    },
    {
        "@type": "Question",
        "name": "What should I wear for water sports in Goa?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "It is advisable to wear a swimsuit, comfortable clothing, and flip-flops for water sports. Don’t forget to apply sunscreen to protect your skin."
        }
    },
    {
        "@type": "Question",
        "name": "Are meals included in the water sports package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some Goa Water Sports Packages may include meals, while others might offer refreshments. Always check the package details before booking."
        }
    },
    {
        "@type": "Question",
        "name": "How do I find the best Goa Water Sports Package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "To find the best Goa Water Sports Package, compare options online, read reviews, and look for promotions on platforms like the Goa App for discounts."
        }
    }
        ]
      }
    ]
  };
},


};



  